import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../../../services/api';
import Modal from '../../../../components/shared/Modal';
import { Search } from 'lucide-react';

const fetchUsers = async () => (await api.get('/users')).data.data;

export default function AddMemberModal({ isOpen, onClose, onAdd }) {
  const [searchTerm, setSearchTerm] = useState('');
  const { data: users, isLoading } = useQuery({
    queryKey: ['allUsers'],
    queryFn: fetchUsers,
    enabled: isOpen
  });

  const filteredUsers = users?.filter(user => 
    user.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Adicionar Membro à Equipe" size="md">
      <div className="space-y-4">
        <div className="relative">
          <Search className="absolute left-3 top-2.5 text-gray-400" size={18} />
          <input
            type="text"
            placeholder="Pesquisar usuários..."
            className="pl-10 w-full border border-gray-300 rounded-md py-2 px-3 text-sm focus:outline-none focus:ring-primary focus:border-primary"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="max-h-64 overflow-y-auto space-y-2">
          {isLoading && <p className="text-center py-4">Carregando usuários...</p>}
          {filteredUsers?.map(user => (
            <div key={user.id} className="flex items-center justify-between p-3 border rounded-lg hover:bg-gray-50 transition-colors">
              <div>
                <p className="text-sm font-medium text-gray-900">{user.nome}</p>
                <p className="text-xs text-gray-500">{user.email}</p>
              </div>
              <button
                onClick={() => onAdd(user.id)}
                className="bg-primary text-white px-3 py-1 rounded text-xs hover:bg-secondary transition-colors"
              >
                Adicionar
              </button>
            </div>
          ))}
          {!isLoading && filteredUsers?.length === 0 && (
            <p className="text-center py-4 text-gray-500">Nenhum usuário encontrado.</p>
          )}
        </div>
      </div>
    </Modal>
  );
}
